import { render, staticRenderFns } from "./LichSuLuuTruList.vue?vue&type=template&id=396de1c0"
import script from "./LichSuLuuTruList.vue?vue&type=script&lang=js"
export * from "./LichSuLuuTruList.vue?vue&type=script&lang=js"
import style0 from "./LichSuLuuTruList.vue?vue&type=style&index=0&id=396de1c0&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports